/*
 * Делегируем обработку кликов от корня документа —
 * так ловим первый «tap», даже если Shopify
 * динамически перерисует хедер.
 * Работает для .lang__currency .disclosure
 */
(() => {
  const selectorRoot = '.lang__currency .disclosure';

  // открыть / закрыть конкретную раскрывашку
  const toggleDisclosure = (wrap, open) => {
    const list = wrap.querySelector('.disclosure__list');
    if (!list) return;
    wrap.classList.toggle('open', open);
    list.classList.toggle('invisible', !open);
  };

  document.addEventListener('click', (e) => {
    // попали ли мы в кнопку-триггер?
    const btn = e.target.closest(`${selectorRoot} .disclosure__button`);
    // все открытые раскрывашки (может быть несколько при переключениях)
    const openWraps = document.querySelectorAll(`${selectorRoot}.open`);

    if (btn) {
      e.preventDefault();                    // блокируем submit формы
      const wrap = btn.closest(selectorRoot);

      // Закрываем чужие раскрывашки
      openWraps.forEach(el => el !== wrap && toggleDisclosure(el, false));

      // Переключаем текущую
      toggleDisclosure(wrap, !wrap.classList.contains('open'));
      return;
    }

    // Кликнули вне триггера — закрываем всё открытое
    openWraps.forEach(el => toggleDisclosure(el, false));
  });
})();
